import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const  store = new Vuex.Store({
	state:{
		wno:'',
		
	},
	mutations: {
		changeUser (state,user) {
			state.wno = user.wno
		}
	},
	getters:{
		getUName: (state)=>{
			return state.uname;
		}
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js